
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9 20C13.4183 20 17 16.4183 17 12C17 7.58172 13.4183 4 9 4C4.58172 4 1 7.58172 1 12C1 16.4183 4.58172 20 9 20Z' fill='#323232'/><path d='M17 5.54999V5.72999C17 6.09999 17.23 6.41999 17.57 6.57999C19.6 7.53999 21 9.60999 21 12C21 14.39 19.6 16.46 17.57 17.42C17.23 17.58 17 17.89 17 18.26V18.44C17 19.12 17.71 19.55 18.32 19.26C21.08 18.01 23 15.23 23 12C23 8.76999 21.08 5.98999 18.32 4.72999C17.71 4.44999 17 4.86999 17 5.54999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-fiber-smart-record`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFiberSmartRecord

    ```js
    <b-new-b-icon-fiber-smart-record />
    ```
</docs>


